import { useQuery } from 'react-query';
import axios from 'axios';
import { PUBLIC_BRANDING_URL } from '@utils/constants/app-constants';

export type PublicBranding = { logo_url: string | null };

const base = (PUBLIC_BRANDING_URL || '').replace(/\/+$/, '');

async function fetchFromApi(o: string): Promise<PublicBranding> {
  try {
    const { data } = await axios.get(base || '/', {
      params: { o },
      timeout: 4000,
      withCredentials: false
    });
    return { logo_url: data?.logo_url ?? null };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    return { logo_url: null };
  }
}

export function usePublicBranding(brandingKey: string | null) {
  return useQuery<PublicBranding>({
    queryKey: ['public-branding', base, brandingKey],
    queryFn: () => fetchFromApi(brandingKey as string),
    enabled: !!brandingKey,
    staleTime: 5 * 60 * 1000
  });
}
